import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Tooltip } from 'tdesign-react';
import CountUp from 'react-countup';
import { convertByte } from '@/utils/common';
import ShadowCard from '@/components/ShadowCard';
import Block from '@/components/Cluster/SummaryBlock';
import TopicTip from '@/components/Cluster/TopicTip';
import HealthGaugeBlock from '../../components/HealthGaugeBlock';

function Summary({ detail }) {
  // const message = fmtNumber(detail.totalMessages, '条');
  const size = convertByte(detail.messageSize);

  return (
    <Root>
      <HealthGaugeBlock
        showConfig
        extra={
          detail.isMetricsCollectDelay && (
            <Tooltip content={detail.delayCollectReason}>
              <DangerIcon src={require('./exclamation.png')} />
            </Tooltip>
          )
        }
      />
      <Block
        title='Brokers'
        info={
          <>
            <CountUp end={detail.activeBrokersCount || 0} duration={0.4} />/
            <CountUp end={detail.brokersCount || 0} duration={0.4} />
          </>
        }
        unit='个'
        theme='blue'
      />
      <Block
        title='Bookies'
        info={
          <>
            <CountUp end={detail.activeBookiesCount || 0} duration={0.4} />/
            <CountUp end={detail.bookiesCount || 0} duration={0.4} />
          </>
        }
        unit='个'
        theme='green'
        items={[
          { label: '读写', value: detail.rwBookiesCount },
          { label: '只读', value: detail.roBookiesCount },
        ]}
      />
      <Block
        title={<TopicTip>Topic</TopicTip>}
        info={
          <>
            <CountUp end={detail.topicPartitionCount || 0} duration={0.4} />/
            <CountUp end={detail.topicCount || 0} duration={0.4} />
          </>
        }
        unit='个'
        theme='yellow'
      />
      <Block
        title='订阅个数'
        info={<CountUp end={detail.subscriptionCount || 0} duration={0.4} />}
        unit='个'
        theme='blue'
        items={[
          { label: '在线', value: detail.subscriptionOnlineCount },
          {
            label: '离线',
            value: (detail.subscriptionCount || 0) - (detail.subscriptionOnlineCount || 0),
          },
        ]}
      />
      <Block
        title='租户个数'
        theme='green'
        info={<CountUp end={detail.tenantCount || 0} duration={0.4} />}
        unit='个'
      />
      <Block
        title='命名空间个数'
        theme='yellow'
        info={<CountUp end={detail.namespaceCount || 0} duration={0.4} />}
        unit='个'
      />
      {/* <Block title='消息条数' info={message.value} unit={message.unit} /> */}
      <Block
        title='消息存储大小'
        theme='blue'
        info={<CountUp end={size.value || 0} decimals={2} duration={0.4} />}
        unit={size.unit}
      />
    </Root>
  );
}

export default connect((state) => ({
  detail: state.cluster.detail,
}))(Summary);

const Root = styled(ShadowCard)``;

const DangerIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 2px;
  cursor: pointer;
  margin-bottom: -2px;
`;
